<script>
//	import { createEventDispatcher } from 'svelte';
  import { fly, fade } from 'svelte/transition';
  import { site } from './store.js'

  export let index
  export let name
  export let logo
  export let logo_width
  export let intro
  export let description
  export let href
  export let open

//	const dispatch = createEventDispatcher();

  $: opened = $site.division.list[index].open
  $: anyOpen = $site.division.list.filter(p => p.open === true).length > 0

  function show(ev){
    site.update(s => {
      (s.division.list.find(i => i.open == true) || {} ).open = false
      s.division.list[index].open = true
      s.division.background = `${s.division.list[index].img}`
      return s
    })
  }

  function hide(){
    site.update(s => {
      s.division.list[index].open = false
      s.division.background = `${s.division.background_default}`
      return s
    })
  }

  function toggle(ev){
    ev.stopPropagation()
    opened ? hide() : show()
  }

  

</script>

<div class="focus-panel cp tac" on:click={toggle} class:opened style="width: {open ? '55%' : anyOpen ? '15%' : '25%'}">
  {#if opened}
    <button class="hide" type="button" on:click|stopPropagation={ hide } in:fade={{delay: 800}}><i class="fas fa-times"></i></button>
    <div class="tac" in:fly="{{ delay: 800,  y: 200, duration: 2000 }}">
      <h3><img src={ logo } alt={ name } style="width: { logo_width };"></h3>
      <p class="description">{ description }</p>
      <a href={ href } class="read-more">VISIT { name.toUpperCase() }</a>
    </div>
  {:else}
    <div class="tac cp" in:fly="{{ y: 200, duration: 2000 }}">
      <h3>{ name }</h3>
      <p class="teaser">{ intro }</p>
    </div>
    <div class="tac show-button" >
      <button class="open" type="button" on:click|stopPropagation={ show } title="Learn more"><i class="fas fa-plus"></i></button>								
    </div>
  {/if}
</div>


<style>
  h3{
    margin-bottom: 40px;
  }
  .focus-panel{
    flex: 1 1 auto;
    transition: width .8s, padding .4s;
    padding: 120px 2%;
    background-color: rgba(23,48,78,.6);
    border-right: 1px solid rgba(255,255,255,0.3);
    color: white;
  }
  .focus-panel:hover{
    background-color: rgba(23,48,78,.4);
    padding-top: 110px;
  }
  .teaser{
    min-height: 6rem;
  }
  .description{
    padding: 0 10%;
  }
  .show-button{
    margin-top: 40px;
    transition: margin .4s;
  }
  .focus-panel:hover .show-button{
    margin-top: 50px;
  }
  .focus-panel.opened{
    cursor: default;
  }
  .focus-panel > div{
  }
  .focus-panels.opened .teaser{
    display: none;
  }
  button{
    cursor: pointer;
    color: #fff;
    padding: 0;
    border: 2px solid #fff;
    border-radius: 50%;
    background-color: transparent;
    height: 26px;
    width: 26px;
    display: inline-block;
    line-height: 1;
  }
  button.hide{
    float: right;
    position: relative; 
    top: -60px;
  }
  a{
    display: inline-block;
    font-size: larger;
    color: #eee;
    padding-bottom: 8px;
  }
</style>
